import { createContext, useState } from "react";

export let NameContext = createContext()
export default function NameContextProvider({children}){
    const [name, setName] = useState('');
    return <NameContext.Provider value={{name, setName}}>
        {children}
    </NameContext.Provider>
}